!function() {
  class t extends HTMLElement {
    loading=!1;
    constructor() {
      super();
    }
    loadProducts() {
      this.product = this.dataset.url.match(/product_id=([0-9]+)/), fetch(this.dataset.url).then((t => t.text())).then((t => {
        const e = document.createElement("div");
        e.innerHTML = t;
        const n = e.querySelector(this.tagName.toLowerCase());
        n && n.innerHTML?.trim().length && (this.innerHTML = n.innerHTML);
      })).catch((t => {
        console.warn(t);
      }));
    }
    connectedCallback() {
      if (this.loadProducts(), this.hasAttribute("data-update")) {
        new MutationObserver(((t, e) => {
          t.forEach((t => {
            this.update();
          }));
        })).observe(this, {
          childList: !1,
          subtree: !1,
          characterData: !1,
          attributes: !0
        });
      }
    }
  }
  customElements.get("product-recommendations") || customElements.define("product-recommendations", t);
}();